import styled from "@emotion/styled";
import { colorPalette } from "../../../theme/colors";

export const ScriptContentArea = styled.div<{
  variant: "default" | "scrollable";
  maxHeight?: string;
  isFeedback?: boolean;
}>`
  font-family: Lexend;
  padding: ${({ isFeedback }) => (isFeedback ? "8px" : "0px")};
  border-radius: ${({ isFeedback }) => (isFeedback ? "4px" : "0px")};
  background-color: ${({ isFeedback }) =>
    isFeedback ? colorPalette.popWhite[500] : "transparent"};
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0.2px;
  cursor: ${({ isFeedback }) => (isFeedback ? "pointer" : "default")};
  color: ${({ isFeedback }) =>
    isFeedback ? colorPalette.popBlack[100] : colorPalette.popBlack[500]};
  min-height: auto;
  text-align: left;
  width: 100%;
  overflow: ${({ variant }) => (variant === "scrollable" ? "auto" : "hidden")};
  max-height: ${({ maxHeight }) => maxHeight || "auto"};

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 4px;
    display: block;
  }

  &::-webkit-scrollbar-track {
    background: ${colorPalette.popWhite[300]};
    border-radius: 4px;
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colorPalette.popOrange[300]};
    border-radius: 4px;
    min-height: 20px !important;
    height: 20px !important;
    width: 4px;
  }

  /* Handle word breaking and overflow */
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;

  & ul {
    list-style-type: disc;
    margin: 8px 0;
    padding-left: 20px;
  }

  & ol {
    list-style-type: decimal;
    margin: 8px 0;
    padding-left: 20px;
  }

  & li {
    margin: 4px 0;
    line-height: 17px;
  }

  /* ✅ ADD: Nested list styles */
  & ul ul {
    list-style-type: circle;
    margin: 4px 0;
  }

  & ul ul ul {
    list-style-type: square;
    margin: 4px 0;
  }

  & ol ol {
    list-style-type: lower-alpha;
    margin: 4px 0;
  }

  & ol ol ol {
    list-style-type: lower-roman;
    margin: 4px 0;
  }

  /* ✅ ADD: Mixed list styles */
  & ul ol,
  & ol ul {
    margin: 4px 0;
  }

  /* ✅ ADD: List item content styling */
  & li p {
    margin: 0;
    display: inline;
  }

  & li ul,
  & li ol {
    margin: 4px 0;
  }

  /* Text elements */
  & p,
  & div,
  & span,
  & strong,
  & em,
  & b,
  & i,
  & u,
  & s {
    text-align: left;
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
    max-width: 100%;
    box-sizing: border-box;
  }

  & strong {
    font-weight: 600;
  }

  & em {
    font-style: italic;
  }

  /* Remove extra spacing from empty paragraphs */
  & p:empty {
    display: none;
  }
`;

export const StyledScriptText = styled.div<{ isFeedback?: boolean }>`
  font-family: Lexend;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.2px;
  text-align: left;
  color: ${({ isFeedback }) =>
    isFeedback ? colorPalette.popBlack[100] : colorPalette.popBlack[500]};
`;

export const ExpandButton = styled.span`
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.2px;
  text-decoration-line: underline;
  color: ${colorPalette.info[500]};
  cursor: pointer;
`;
